import { getServiceApiErrorBody } from '@/hooks/getServiceApiErrorBody'

/**
 * Maps the adjust-balance / cancel-plan API error codes (QMD-4371) to a user-facing
 * message. The Orval fetcher rejects with the API error body on `details`; we read
 * its `ErrorCode` and fall back to a generic message for anything unmapped.
 */
const MESSAGES: Record<string, string> = {
  ReasonNotValid: 'A reason is required.',
  PackageVisitsRemainingNotValid: 'The new balance must be between 0 and the visits purchased.',
  PackageExpired: 'This plan has expired and can no longer be changed.',
  Permission: 'You do not have permission to edit this plan.',
  PatientNotFound: 'Patient not found.',
  PackageNotFound: 'Plan not found.',
  PackageVisitTypeNotFound: 'That visit type is not covered by this plan.',
  BadRequest: 'Something was wrong with the request. Please try again.',
}

const hasErrorCode = (value: unknown): value is { ErrorCode: unknown } =>
  typeof value === 'object' && value !== null && 'ErrorCode' in value

export function getEditPlanVisitsErrorMessage(error: unknown): string {
  const body = getServiceApiErrorBody(error)
  const code = hasErrorCode(body) ? body.ErrorCode : undefined
  const mapped = typeof code === 'string' ? MESSAGES[code] : undefined

  return mapped ?? 'Something went wrong. Please try again.'
}
